module.exports = __webpack_public_path__ + "media/images/emblems/Chalais_VS-coat_of_arms-2c2adc79d4111bf9105c6058f1e16f5b.svg";